const generateUniqueId = () => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import api from './api';

export type ImageType = 'profile' | 'background';

interface UploadImageOptions {
  file: File;
  type: ImageType;
  userId: string;
}

interface UploadImageResponse {
  imageUrl: string;
  thumbnailUrl?: string;
}

export class ImageService {
  private static BASE_URL = '/users';

  private static getStoragePath(options: UploadImageOptions): string {
    const timestamp = Date.now();
    const imageId = generateUniqueId();
    const { userId, type } = options;

    const paths = {
      profile: `user-profiles/${userId}/${timestamp}_${imageId}`,
      background: `user-profiles/${userId}/backgrounds/${timestamp}_${imageId}`,
    };

    return paths[type];
  }

  static async uploadImage(
    options: UploadImageOptions
  ): Promise<UploadImageResponse> {
    try {
      const { file, type } = options;
      const storagePath = this.getStoragePath(options);

      // Get storage reference
      const storage = getStorage();
      const storageRef = ref(storage, storagePath);

      // Upload file with metadata
      const metadata = {
        contentType: file.type,
        customMetadata: {
          userId: options.userId,
          type,
          uploadedFrom: window.location.origin,
        },
      };

      // Upload file
      console.log(`Uploading ${type} image to:`, storagePath);
      const uploadResult = await uploadBytes(storageRef, file, metadata);
      console.log('Upload completed:', uploadResult);

      const imageUrl = await getDownloadURL(storageRef);
      console.log('Download URL obtained:', imageUrl);

      // Send URL to backend for processing
      const endpoint =
        type === 'profile'
          ? 'profile/image/process'
          : 'profile/background/process';
      const response = await api.post<UploadImageResponse>(
        `${this.BASE_URL}/${endpoint}`,
        { imageUrl }
      );

      return response.data;
    } catch (error) {
      console.error('Error uploading image:', error);
      if (error instanceof Error) {
        throw new Error(
          `Error uploading ${options.type} image: ${error.message}`
        );
      }
      throw error;
    }
  }
}
